"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiStepperStyles = void 0;
// import { parseRSPToken } from '@rentspree/component-2023.utils.token-parser'
exports.muiStepperStyles = {
    /*
     * styleOverrides: {
     *   root: {
     *     padding: parseRSPToken('rsp.comp.stepper.container.padding-bt-element'),
     *     width: '100%',
     *   },
     * },
     */
    defaultProps: {
        alternativeLabel: true,
    },
};
//# sourceMappingURL=stepper.js.map